export default __webpack_public_path__ + "static/media/Boton Verde.bbc85c48.svg";